import * as actionTypes from '../action-types';
import {
  getNotifications,
  setNotificationAsRead,
  openNotificationsList,
} from '../../notification.api';
import { NotificationType } from '../../notification.types';

const setNotifications = (notifications: Array<NotificationType>) =>
  <const>{
    type: actionTypes.SET_NOTIFICATIONS,
    payload: { notifications },
  };

const markNotificationAsRead = (notificationId: number) =>
  <const>{
    type: actionTypes.MARK_NOTIFICATION_AS_READ,
    payload: { notificationId },
  };

const markNotificationsAsRead = (notificationsList: Array<number>) =>
  <const>{
    type: actionTypes.MARK_NOTIFICATIONS_AS_READ,
    payload: { notificationsList },
  };

const setIsNew = (isNew: boolean) =>
  <const>{
    type: actionTypes.SET_IS_NEW,
    payload: { isNew },
  };

export const fetchNotifications = () => async (dispatch: Function) => {
  const { data } = await getNotifications();
  dispatch(setNotifications(data.notifList));
  dispatch(setIsNew(data.isNew));
};

export const notificationSelected = (notificationId: number) => async (
  dispatch: Function,
) => {
  await setNotificationAsRead(notificationId);
  dispatch(markNotificationAsRead(notificationId));
};

export const notificationsDisplayed = (lastNotifShownId: number) => async (
  dispatch: Function,
) => {
  await openNotificationsList(lastNotifShownId);
  dispatch(setIsNew(false));
};

export const setNotificationsAsRead = (
  notificationsList: Array<number>,
) => async (dispatch: Function) => {
  dispatch(markNotificationsAsRead(notificationsList));
};

export type NotificationsActions = ReturnType<
  | typeof setNotifications
  | typeof markNotificationAsRead
  | typeof markNotificationsAsRead
  | typeof setIsNew
>;
